import { Component, OnInit, OnDestroy } from '@angular/core';
import { BasePageComponent } from '../base-page';
import { Store } from '@ngrx/store';
import { IAppState } from '../../interfaces/app-state';
import { HttpService } from '../../services/http/http.service';
import { Content } from '../../ui/interfaces/modal';
import { TCModalService } from '../../ui/services/modal/modal.service';
import Swal from 'sweetalert2'
import swal from 'sweetalert2'
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
// import {MainService 
// } from './main.service'
import { Spinkit } from 'ng-http-loader'; //
import { Router } from '@angular/router'
import { element } from 'protractor';

@Component({
  selector: 'app-restaurant-tables',
  templateUrl: './restaurant-tables.component.html',
  styleUrls: ['./restaurant-tables.component.scss']
})
export class RestaurantTablesComponent extends BasePageComponent implements OnInit, OnDestroy {

  restoID;
  data = [];
  public spinkit = Spinkit;
  public file: any;
  public imageFile: any;
  tableId;
  imgurl;
  errorMessage;
  tablestatus;
  deleteStatus = "Deleted";
  restaurant_table_name
  restaurant_table_id
  tableDeatils = []
  tableName: any;
  valuetableName
  web_table_id
  value;
  r_id
  constructor(
    store: Store<IAppState>,
    httpSv: HttpService,
    private modal: TCModalService,
    private httpClient: HttpClient,
    private router: Router
  ) {
    super(store, httpSv);
  }

  ngOnInit() {
    this.restoID = localStorage.getItem('restoID');
    super.ngOnInit();
    this.getTabledetail()
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  getTabledetail() {
    this.httpSv.getTabledetail().subscribe(
      response => {
        if (response['status'] == true) {
          this.tableDeatils = response['result'].data;
          this.tableId = response['result'].data.restaurant_table_id
          const result = this.tableDeatils.filter(s => s.restaurant_table_name == 'Web');
          result.forEach(ele => {
            ele.restaurant_table_id
            this.web_table_id = ele.restaurant_table_id
            this.r_id = ele.restaurant_table_r_id
          })
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  logout() {
    this.httpSv.logout().subscribe(
      response => {
        localStorage.clear();
        setTimeout(()=>{
          this.router.navigate(['/public/sign-in'])
        })
      },
      err => {
        console.log(err);
      }
    );
  }
  downLoadQrWeb() {
    this.httpSv.downLoadQr(this.web_table_id, this.r_id).subscribe(
      response => {
        if (response['status'] == true) {
          this.imgurl = response['result'].data.url
          const imgName = this.imgurl.substr(this.imgurl.lastIndexOf('/') + 1);
          this.httpClient.get(this.imgurl, { responseType: 'blob' as 'json' })
            .subscribe((res: any) => {
              const file = new Blob([res], { type: res.type });
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file);
                return;
              }
              const blob = window.URL.createObjectURL(file);
              const link = document.createElement('a');
              link.href = blob;
              link.download = imgName;
              link.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
              }));
              setTimeout(() => {
                window.URL.revokeObjectURL(blob);
                link.remove();
              }, 100);
            });
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }

  downLoadQr(id, restaurant_id) {
    this.httpSv.downLoadQr(id, restaurant_id).subscribe(
      response => {
        if (response['status'] == true) {
          this.imgurl = response['result'].data.url
          const imgName = this.imgurl.substr(this.imgurl.lastIndexOf('/') + 1);
          this.httpClient.get(this.imgurl, { responseType: 'blob' as 'json' })
            .subscribe((res: any) => {
              const file = new Blob([res], { type: res.type });
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(file);
                return;
              }
              const blob = window.URL.createObjectURL(file);
              const link = document.createElement('a');
              link.href = blob;
              link.download = imgName;
              link.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
              }));
              setTimeout(() => {
                window.URL.revokeObjectURL(blob);
                link.remove();
              }, 100);
            });
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }

  deleteTable(value) {
    this.httpSv.deleteTable(value).subscribe(
      response => {
        if (response['status'] == true) {
          Swal.fire(response['message'])
          this.ngOnInit();
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  deleteTablepopup(value) {
    Swal.fire({
      text: "Are you Sure ??",
      showCancelButton: true,
      icon: "warning",
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete ',
      cancelButtonColor: '#d33',
    })
      .then((result) => {
        if (result.isConfirmed) {
          this.httpSv.deleteTable(value).subscribe(
            response => {
              if (response['status'] == true) {
                location.reload();
              }
            }, (err: HttpErrorResponse) => {
              this.errorMessage = err.error.message;
              if (err.status == 401 || err.status == 500) {
                this.logout();
              }
            }
          )
        }
      });
  }
  addTable() {
    Swal.fire({
      text: "Table Name",
      input: 'text',
      showCancelButton: true
    })
      .then((result) => {
        if (result.value) {
          this.httpSv.addnewTable(result.value).subscribe(
            response => {
              if (response['status'] == true) {
                Swal.fire(response['message'])
                this.ngOnInit();
              }
            }, (err: HttpErrorResponse) => {
              this.errorMessage = err.error.message;
              if (err.status == 401 || err.status == 500) {
                this.logout();
              }
            }
          )
        }
      });
  }
  updateTableStatus(id, status) {
    this.httpSv.updateTableStatus(id, status).subscribe(
      response => {
        if (response['status'] == true) {
          this.ngOnInit();
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  openModals<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null, id) {
    this.httpSv.getEditdata(id).subscribe(
      response => {
        if (response['status'] == true) {
          this.value = response['result'].data
          this.restaurant_table_id = id
          this.restaurant_table_name = response['result'].data.restaurant_table_name
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
    });
  }
  closeModal() {
    this.modal.close();
  }
  updateTableName(id, name) {
    this.httpSv.updateTableName(id, name).subscribe(
      response => {
        this.closeModal();
        Swal.fire(response['message'])
        this.ngOnInit();
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  Onclickbutton() {
    this.router.navigate(['horizontal/main']);
  }
}
